// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1M2bP","buttons":"RemoveExpirationActionButtons_buttons__1sXAE"};